import React from 'react';
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg';
import icChecked from 'assets/svgs/checkbox-enabled-checked.svg';
import icUnchecked from 'assets/svgs/checkbox-enabled-unchecked.svg';

import {
  StyledCheckbox,
  StyledCheckboxLabel,
} from './styles';

const Checkbox = ({
  onChange, checked, label, className, disabled,
}) => {
  const handleCheck = () => {
    onChange(!checked);
  };

  return (
    <StyledCheckbox onClick={handleCheck} className={className} disabled={disabled}>
      <ReactSVG src={checked ? icChecked : icUnchecked} />
      {label && <StyledCheckboxLabel>{label}</StyledCheckboxLabel>}
    </StyledCheckbox>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
  label: null,
  className: null,
  disabled: false,
};

export default Checkbox;
